import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getHistory } from 'js/history';

const withRouter = Component => {
  const ComponentWithRouterProp = React.forwardRef((props, ref) => {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let history = getHistory();
    return (
      <Component
        {...props}
        ref={ref} // Pass the ref to the wrapped component
        location={location}
        routeParams={params}
        navigate={navigate}
        history={history}
      />
    );
  });
  ComponentWithRouterProp.displayName = 'ComponentWithRouterProp';
  return ComponentWithRouterProp;
};
export default withRouter;
